import { render, staticRenderFns } from "./ConsolidaResultadosDialog.vue?vue&type=template&id=db872ad0&"
import script from "./ConsolidaResultadosDialog.vue?vue&type=script&lang=js&"
export * from "./ConsolidaResultadosDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports